import GradingDetail from "@/controllers/grading/grading-detail.js";
import axios from "axios";
import store from '@/store';

export default {
  extends: GradingDetail,

  methods: {
    async getGradingDetail() {
      try {
        this.isLoading = true;

        const response = await axios.get("/grading/gradingDetail/" + this.$route.params.student_id, {
          params: {
            campus_id: store.state.user.campus_id,
            exam_id: this.$route.params.exam_id,
            class_id: this.$route.query.class_id
          },
        });
        if (response.data[0] != undefined) {
          this.gradingInfo = response.data[0];
        }
      } catch (error) {
        if (error.response && error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        console.error("Grading Detail API Error", error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
